export default __webpack_public_path__ + "resources/icons/d130-60e8.webp";